module.exports = __webpack_public_path__ + "media/components/theme/fonts/GT-Pressura-Mono-Bold-84272dcec398d2aa7170c70f3869a6ff.ttf";